
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import {
  ClientApi,
  Client,
  PricePlanEnum,
  GetServicePlan,
  GetPricePlan,
  SystemApi,
  ServicePlanEnum,
  ClientScheduledChangeEnum
} from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  name: string;
  pricePlan: PricePlanEnum;
  max_employees: string;
};
const ServicePlans = Object.values(ServicePlanEnum);
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class ClientForm extends FormMixin {
  @Prop({ type: Object }) client?: Client;
  availableServicePlans: GetServicePlan[] = [];
  availablePricePlans: GetPricePlan[] = [];
  formName = "クライアント";
  defaultMaxEmployees = "3";
  formValues: FormValues = {
    name: "",
    pricePlan: PricePlanEnum.Trial,
    max_employees: ""
  };
  currentPricePlan = "";
  displayMaxEmployee = false;
  validationSchema!: yup.AnyObjectSchema;
  message = "";
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "クライアント名" }))
    });
  }
  get planStart() {
    let date = null;
    if (this.client?.planStart) date = new Date(this.client.planStart);
    else if (this.client?.createdAt) date = new Date(this.client.createdAt);
    return date ? `${date.getFullYear()}年${date.getMonth() + 1}月` : "";
  }
  get planEnd() {
    const date = this.client?.planEnd && new Date(this.client.planEnd);
    return date ? `${date.getFullYear()}年${date.getMonth() + 1}月` : "";
  }
  async beforeMount() {
    const getServicePlansResponse = await new SystemApi().getServicePlans({});
    this.availableServicePlans = getServicePlansResponse.data;
    const getPricePlansResponse = await new SystemApi().getPricePlans({});
    this.availablePricePlans = getPricePlansResponse.data;
    this.formValues = this.client
      ? {
          name: this.client.name,
          pricePlan: this.client.pricePlan,
          max_employees: this.client.max_employees ? this.client.max_employees : "",
          ...Object.keys(ServicePlanEnum).reduce((prev, current) => {
            prev[current.toLowerCase()] = (this.client!.servicePlans || [])
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              .includes((ServicePlanEnum as any)![current]);
            return prev;
          }, {} as { [key: string]: boolean })
        }
      : {
          name: "",
          pricePlan: PricePlanEnum.Trial,
          max_employees: "",
          ...Object.keys(ServicePlanEnum).reduce((prev, current) => {
            prev[current.toLowerCase()] = false;
            return prev;
          }, {} as { [key: string]: boolean })
        };
    this.currentPricePlan = this.formValues.pricePlan;
    this.displayMaxEmployee = this.formValues.pricePlan === PricePlanEnum.Trial ? true : false;
    if (this.client?.scheduledChanges && this.client?.scheduledChanges.length) {
      const scheduledChange = this.client.scheduledChanges[0];
      const date = new Date(scheduledChange.plannedDate as string);
      const dateStr = `${date.getFullYear()}年${date.getMonth() + 1}月`;
      if (scheduledChange.plannedAction === ClientScheduledChangeEnum.ChangePlan) {
        const plan = this.availablePricePlans.find(({ code }) => code === scheduledChange.targetPricePlan);
        const planName = plan ? plan.name : scheduledChange.targetPricePlan;
        this.message = `「${dateStr}に${planName}に変更予定です」`;
      } else if (scheduledChange.plannedAction === ClientScheduledChangeEnum.Delete) {
        this.message = `「${dateStr}に削除予定です」`;
      }
    }
  }
  async onBeforeSubmit(formValues: FormValues) {
    await this.onSubmit(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const servicePlans = ServicePlans.filter(key => (formValues as any)[key]);
      let max_employees = "";
      if (formValues.pricePlan === PricePlanEnum.Trial) {
        if (this.client) {
          max_employees = formValues.max_employees;
        } else {
          max_employees = formValues.max_employees ? formValues.max_employees : this.defaultMaxEmployees;
        }
      }
      const submitValues = {
        name: formValues.name,
        servicePlans,
        pricePlan: formValues.pricePlan,
        max_employees: max_employees
      };
      if (this.client) {
        await new ClientApi().updateClient({
          clientId: this.client.id,
          updateClientRequest: submitValues
        });
      } else {
        await new ClientApi().createClient({
          createClientRequest: submitValues
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new ClientApi().deleteClient({ clientId: this.client!.id! });
    });
  }
  onPricePlanChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.currentPricePlan = target.value;
    this.displayMaxEmployee = target.value === PricePlanEnum.Trial ? true : false;
  }
}
